import { z } from 'zod';

export const getDeviceConfigurationBaseSchema = z.array(
  z.object({
    id: z.string(),
    code: z.string().optional(),
    name: z.string().optional(),
    deleted: z.boolean(),
    documentTypeID: z.string(),
    documentSeriesID: z.string(),
    companySiteID: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    boid: z.string().optional(),
  })
);

export type GetAllDeviceConfigurationsResponse = z.infer<typeof getDeviceConfigurationBaseSchema>;
